import React, { useState, useEffect, useRef, useMemo } from 'react';
import {
  Input,
  Popover,
  Button,
  Modal,
  InputNumber,
} from '@bedrock/components';
import { useClickAway, useMemoizedFn } from 'ahooks';
import cx from 'classnames';
import './index.less';

//自定义受控组件
export type TextAreaPopconfirmProps = {
  view?: boolean;
  value?: string;
  emptyText?: string;
  wrapperClassName?: string;
  wrapperStyle?: React.CSSProperties;
  topSlot?: React.ReactNode;
  editable?: boolean;
  onChange?: (value: string) => void;
  column?: any;
  row?: any;
  rowIndex?: number;
};

export default function InputNumberWithTopSlot({
  value,
  onChange,
  view = false,
  emptyText = '--',
  wrapperClassName,
  wrapperStyle,
  topSlot,
  ...otherProps
}: TextAreaPopconfirmProps) {
  if (!otherProps?.editable || view) {
    if (typeof otherProps?.column?.render === 'function') {
      return otherProps.column.render(
        value,
        otherProps.row,
        otherProps.rowIndex
      );
    }

    return (
      <div className={cx(wrapperClassName)} style={wrapperStyle}>
        {!value ? emptyText : value}
      </div>
    );
  }

  return (
    <div className={cx(wrapperClassName)} style={wrapperStyle}>
      {topSlot}
      <InputNumber value={value} onChange={onChange} {...otherProps} />
    </div>
  );
}
